import React, { Component, Fragment } from "react";
import AddIcon from "@mui/icons-material/Add";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import CloseIcon from "@mui/icons-material/Close";
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import postService from "../../services/postService";
import LoadingButton from "@mui/lab/LoadingButton";
import FieldLengthLabel from "../commons/FieldLengthLabel";
import userService from "../../services/userService";

const textFieldStyles = {
  InputProps: {
    style: {
      fontFamily: "inherit",
    },
  },
  InputLabelProps: {
    style: {
      fontFamily: "inherit",
    },
  },
};

class NewPost extends Component {
  state = {
    showEdit: false,
    data: {
      title: "",
      body: "",
      category: "none",
    },
    newPostRequestLoading: false,
    error: "",
  };

  componentDidMount = () => {
    this.selectCurrentCategory();
    window.addEventListener("beforeunload", (event) => {
      event.preventDefault()
      const { showEdit } = this.state;
      if (showEdit) {
        event.returnValue = "Confirm exit?";
      }
    });
  };

  selectCurrentCategory = () => {
    const { currentTopic } = this.props;
    const data = { ...this.state.data };
    data.category = currentTopic ? currentTopic.id : "none";
    this.setState({
      data,
    });
  };

  handleChange = ({ target: input }) => {
    const data = { ...this.state.data };
    data[input.name] = input.value;
    this.setState({
      data,
    });
  };

  startLoading() {
    this.setState({
      newPostRequestLoading: true,
    });
  }

  finishLoading() {
    this.setState({
      newPostRequestLoading: false,
    });
  }

  makeNewPost = async () => {
    this.startLoading();
    this.setState({ error: "" });
    const { title, body, category: categoryId } = this.state.data;
    const { onCreatedNewPost } = this.props;
    try {
      await postService.newPost(
        title,
        body,
        isNaN(categoryId) ? "" : categoryId
      );
      this.finishLoading();
      this.revert(() => {
        this.selectCurrentCategory();
      });
      onCreatedNewPost(categoryId);
    } catch (error) {
      this.finishLoading();
      if (error.response) {
        this.setState({
          error: error.response.data.message,
        });
      }
    }
  };

  revert = (callback) => {
    this.setState(
      {
        showEdit: false,
        data: {
          title: "",
          body: "",
          category: "",
        },
      },
      callback
    );
    this.selectCurrentCategory();
  };

  render() {
    const { showEdit, data, error, newPostRequestLoading } = this.state;
    const { topics } = this.props;

    const postBodyMaxLen = process.env.REACT_APP_POST_BODY_MAXLEN;
    const postTitleMaxLen = process.env.REACT_APP_POST_TITLE_MAXLEN;

    const currentUser = userService.getCurrentUser();
    return (
      <Fragment>
        {!showEdit ? (
          <div
            className="new-post-label"
            onClick={() => this.setState({ showEdit: true })}
          >
            <div>
              <AddIcon style={{ marginRight: 10 }} />
              <h3 className="heading">New Post</h3>
            </div>
          </div>
        ) : (
          <div className="new-post-edit">
            <h2 className="heading">
              New Post{" "}
              <CloseIcon className="icon" onClick={() => this.revert()} />
            </h2>
            <div className="input-container" style={{ marginBottom: 10 }}>
              <TextField
                fullWidth
                label="Title"
                variant="standard"
                name="title"
                {...textFieldStyles}
                inputProps={{ maxLength: postTitleMaxLen }}
                value={data.title}
                onChange={this.handleChange}
              />
              <FieldLengthLabel
                length={data.title.length}
                maxLength={postTitleMaxLen}
              />
            </div>
            <div className="input-container">
              <TextField
                fullWidth
                label="Body"
                variant="standard"
                name="body"
                multiline
                maxRows={5}
                {...textFieldStyles}
                inputProps={{ maxLength: postBodyMaxLen }}
                value={data.body}
                onChange={this.handleChange}
              />
              <FieldLengthLabel
                length={data.body.length}
                maxLength={postBodyMaxLen}
              />
            </div>
            {error && <div className="alert">{error}</div>}
            <div
              className="footer"
              style={{
                justifyContent: "space-between",
                marginTop: error ? 10 : 25,
              }}
            >
              <FormControl fullWidth style={{ width: "50%" }} size="small">
                <InputLabel shrink id="category-select-label">
                  Category
                </InputLabel>
                <Select
                  labelId="category-select-label"
                  id="category-select"
                  value={data.category}
                  name="category"
                  label="Category"
                  onChange={this.handleChange}
                  displayEmpty
                  style={{
                    fontFamily: "inherit",
                  }}
                >
                  <MenuItem value="none">None</MenuItem>
                  {topics
                    .filter(
                      (topic) =>
                        !topic.adminOnly ||
                        (topic.adminOnly && currentUser.isAdmin)
                    )
                    .map((topic) => (
                      <MenuItem key={topic.id} value={topic.id}>
                        {topic.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <LoadingButton
                variant="contained"
                id="post-button"
                onClick={this.makeNewPost}
                style={{
                  fontFamily: "inherit",
                  backgroundColor: "var(--theme-orange)",
                }}
                endIcon={<RocketLaunchOutlinedIcon />}
                loading={newPostRequestLoading}
                disabled={newPostRequestLoading}
              >
                Post
              </LoadingButton>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default NewPost;
